const API_BASE = process.env.REACT_APP_API_URL || '/api';

async function request(url, options = {}) {
    const resp = await fetch(`${API_BASE}${url}`, {
        headers: { 'Content-Type': 'application/json', ...options.headers },
        ...options,
    });
    if (!resp.ok) {
        const data = await resp.json().catch(() => ({}));
        const err = new Error(data.detail || 'Ошибка сервера');
        err.data = data;
        err.status = resp.status;
        throw err;
    }
    return resp.json();
}

export const getServices = () => request('/services/');
export const getService = (id) => request(`/services/${id}/`);
export const getAvailableDates = (id) => request(`/services/${id}/available-dates/`);
export const getAvailableTimes = (id, date) => request(`/services/${id}/available-times/?date=${date}`);
export const getClubs = (serviceId) =>
    request(`/clubs/${serviceId ? `?service_id=${serviceId}` : ''}`);
export const createBooking = (data) => request('/bookings/', {
    method: 'POST',
    body: JSON.stringify(data),
});
